import { IdhaAppException } from "../../../../js/idha-app-exception";
import { material } from "angular";
import { stringify } from "querystring";
import { ThermOfUse } from "@idha/idha-types";
import { ThermOfUseAdherenceService } from "../../services/thermOfUseAdherenceService";
import { utilsModule } from "../../utils-module";
import { ICpf, ICnpj, ICpfCnpj } from "../../../utils/services/cpfCnpjService";
import { isNullOrEmpty } from "modules/app/reactComponents/packing/sanitization-steps/components/presentation/validationsFunctions";
import { isNotNullOrEmpty } from "modules/utils/isNotNullOrEmpty";
import { managerApi } from "api/managerApi";

function loginRegisterController($scope, Person, UserIdha, $state, localStorageService,
    LoadingBar, dialogs, $translate, LoginService, History, $mdDialog, idhaApiError, thermOfUseAdherenceService: ThermOfUseAdherenceService, cpf: ICpf,cnpj: ICnpj, cpfCnpj: ICpfCnpj,) {
    let ctrl = this;
    // === DADOS USADOS PARA REGISTRO DA PESSOA/USUARIO ===
    //objeto usado para cadastro da pessoa
    let person = undefined;

    //objeto usado para cadastro do primeiro usuário
    let user = undefined;
    let passwordConfirmation: string = undefined;
    // === FIM ===

    // === DADOS USADOS PARA LOGIN DE UMA PESSOA/USUARIO EXISTENTES ===
    let login: string = undefined;
    let password: string = undefined;
    let loginFailed: boolean = false;
    // === FIM ===



    ctrl.$onInit = async function () {

        $scope.forms = {};
        //console.log(cpf.isValid(cpfCnpj.strip(ctrl.identifier)));
        ctrl.identifierType = ctrl.type_cpf_cnpj_email(ctrl.identifier)

        ctrl.selectedPersonType = (ctrl.identifierType != 'EMAIL') ? ctrl.identifierType : undefined;

        try {
            if (ctrl.identifier) {
                //verificar se a pessoa ja existe no servidor
                let checkPersonExistenceResponse: {
                    personExistsForGivenIdentifier: boolean,
                    personId: string,
                    userId: string,
                    userExistsForGivenIdentifier: boolean
                } = await Person.checkPersonAndUserExistence({
                    identifier: ctrl.identifier,
                    identifierType: ctrl.identifierType
                }).$promise;

                //se a pessoa existir, buscar seus dados, caso contário preencher os dados conhecidos localmente
                //para posterior cadastro
                if (checkPersonExistenceResponse.personExistsForGivenIdentifier) {
                    /*ctrl.person = await Person.findById({ id: checkPersonExistenceResponse.personId });

                    //se for uma pessoa física o login é o próprio identificador fornecido
                    //se for uma pessoa jurídica o login fica em branco para ser preenchido pelo usuário como sendo o
                    //email do usuário
                    if (ctrl.identifierType == "CPF" || ctrl.identifierType == "EMAIL") {
                        ctrl.login = ctrl.identifier;
                    }*/

                    if (checkPersonExistenceResponse.personExistsForGivenIdentifier) {
                        dialogs.alert($translate.instant(`${ctrl.identifierType}_ALREADY_REGISTERED`)).then(() => {
                            $state.go('login');
                        })
                    }

                } else {
                    //inicializar os objetos que vão receber os dados da pessoa/usuário sendo registrado
                    ctrl.person = {
                        country: 'Brasil'
                    };
                    ctrl.user = {
                        address: {
                            country: 'Brasil'
                        }
                    };

                    ctrl.person.identifier = ctrl.identifierType;

                    if (ctrl.identifierType == "CPF") {
                        ctrl.person.cpf = ctrl.identifier;
                    } else if (ctrl.identifierType == "EMAIL") {
                        ctrl.person.email = ctrl.identifier;
                    } else if (ctrl.identifierType == "CNPJ") {
                        ctrl.person.cnpj = ctrl.identifier;
                        ctrl.user.name = ''
                    }
                }
            } else {
                ctrl.person = {
                    country: 'Brasil'
                };
                ctrl.user = {
                    address: {
                        country: 'Brasil'
                    }
                };
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    ctrl.passwordMatch = function (): boolean {
        if (!ctrl.user || !ctrl.user.password || !ctrl.passwordConfirmation) {
            return false;
        }

        if (ctrl.user.password == ctrl.passwordConfirmation) {
            return true;
        } else {
            return false;
        }
    }

    ctrl.type_cpf_cnpj_email = function (valor: string) {
        if (cpf.isValid(valor)) {
            return 'CPF';
        }
        else if (cnpj.isValid(valor)) {
            return 'CNPJ';
        }
        else if (ctrl.ownerIdIsEmail(valor)) {
            return 'EMAIL';
        }
        return undefined;
    }

    ctrl.ownerIdIsEmail = function (validEmail: string) {
        let emailRegex: RegExp = /^[a-zA-Z0-9.-_]*@[a-zA-Z0-9.-_]*$/;
        return emailRegex.test(validEmail);
    }

    // @TODO: verificar se o nome da pessoa sendo salva e do usuário são o mesmo, caso a pessoa seja uma pessoa física
    ctrl.continueWithRegister = async function () {
        try {
            ctrl.validated = true;
            if ($scope.forms.formRegister.$invalid) {
                throw new IdhaAppException($translate.instant("VERIFY_INFORMED_DATA"));
            }

            if (isNotNullOrEmpty(ctrl.user.cellphone) && isNullOrEmpty(ctrl.cellphoneConfirmation)) {
                alert(`Informe a confirmação do celular`)
                return
            }

            if (isNotNullOrEmpty(ctrl.person.email) && isNullOrEmpty(ctrl.emailConfirmation)) {
                alert(`Informe a confirmação do email`)
                return
            }

            if (isNullOrEmpty(ctrl.user.password) || isNullOrEmpty(ctrl.passwordConfirmation)) {
                alert(`Informe a senha e a confirmação da senha`)
                return
            }

            if (isNullOrEmpty(ctrl.person.email) && isNullOrEmpty(ctrl.user.cellphone)) {
                alert(`Informe email, telefone ou ambos`)
                return
            }

            
            ctrl.user.email = ctrl.person.email;
            
            if (ctrl.person.cpf && !ctrl.person.cnpj) {
                ctrl.user.cpf = ctrl.person.cpf;
                ctrl.user.name = ctrl.person.name;
                ctrl.user.address = {
                    address: ctrl.person.address,
                    complement: ctrl.person.complement,
                    number: ctrl.person.number,
                    district: ctrl.person.district,
                    city: ctrl.person.city,
                    state: ctrl.person.state,
                    country: ctrl.person.country,
                    zipCode: ctrl.person.zipCode
                }
            }

            if (ctrl.user.email) ctrl.user.email = ctrl.user.email.toLowerCase();
            if (ctrl.user.username) ctrl.user.username = ctrl.user.email.toLowerCase();
            if (ctrl.person.email) {
                ctrl.person.email = ctrl.person.email.toLowerCase();
                ctrl.user.email = ctrl.person.email.toLowerCase();
            }

            if (ctrl.user.cellphone) {
                ctrl.person.cellphone = ctrl.user.cellphone;
            }


            
            if (ctrl.person.cpf) {
                ctrl.person.identifier = 'CPF'
            } else if (ctrl.person.cnpj) {
                ctrl.person.identifier = 'CNPJ'
            }

            await LoadingBar.show();

            const validateForUserEmail = ctrl.user.email ? await managerApi.Person.checkPersonAndUserExistence({
                identifier: ctrl.person.identifier == "CPF" ? ctrl.person.cpf : ctrl.person.cnpj,
                identifierType: ctrl.person.identifier,
                email: ctrl.user?.email
            }) : null
    
            const validateForUserCellphone = ctrl.user.cellphone ? await managerApi.Person.checkPersonAndUserExistence({
                identifier: ctrl.person.identifier == "CPF" ? ctrl.person.cpf : ctrl.person.cnpj,
                identifierType: ctrl.person.identifier,
                cellphone: ctrl.user?.cellphone
            }) : null

            const personExists = validateForUserEmail?.personExistsForGivenIdentifier || validateForUserCellphone?.personExistsForGivenIdentifier;
            const userExists = validateForUserEmail?.userExistsForGivenIdentifier || validateForUserCellphone?.userExistsForGivenIdentifier;

            if (personExists) {
                LoadingBar.hide();
                alert(`Ja existe um cadastro de organização com este CPF ou CNPJ`)
                return
            }

            if (userExists) {
                LoadingBar.hide();
                alert(`Já existe um usuário cadastrado com este email ou telefone`)
                return
            }

            LoadingBar.hide()

            let thermOfUse: ThermOfUse = await thermOfUseAdherenceService.showThermsOfUseDlg('management');

            let registerNewPersonResponse: { personId: string, user } = await Person.registerNewPerson(undefined, {
                person: ctrl.person,
                firstUser: ctrl.user,
                thermOfUseId: thermOfUse.id
            }).$promise;

            if (!ctrl.concludeCallback) {
                try {
                    
                    LoadingBar.hide();

                   

                    $state.go(`verify-email-phone`, {
                        email: isNotNullOrEmpty(ctrl.user.email) ? ctrl.user.email : undefined, 
                        phone: isNotNullOrEmpty(ctrl.user.cellphone) ? ctrl.user.cellphone : undefined,
                        userId: registerNewPersonResponse.user.id.toString()
                    })

                   

                } catch (err) {
                    
                    LoadingBar.hide();
                    $mdDialog.show($mdDialog.alert()
                        .title('Seja Bem Vindo!')
                        .textContent('Seu cadastro foi realizado com sucesso, mas ocorreu um erro inesperado ao lhe enviar o email de confirmação. Tente realizar seu login utilizando o email e senha cadastrados e, caso não consiga, entre em contato com o suporte IDHA (suporte@idha.com.br)"')
                        .ariaLabel('bem vindo')
                        .ok('OK! ')).then(async function () {
                            $state.go("login", { email: ctrl.user.email });
                        });
                }
            } else {
                ctrl.concludeCallback(registerNewPersonResponse);
            }

            function showConfirmDialog() {
                $mdDialog.show(confirm).then(async function () {
                    //realizar o login do usuário recém criado
                    try {
                        LoadingBar.show();
                        await LoginService.login(ctrl.user.email, ctrl.user.password);
                        LoadingBar.hide();
                    } catch (err) {
                        await LoadingBar.hide();
                        showConfirmDialog();
                    }
                }, function () {
                    dialogs.confirm("Tem certeza que deseja confirmar seu email depois? Após validar seu email, você deverá realizar login com seu email e senha cadastrados", "Sim", "Não")
                        .then(() => {
                            $state.go('login')
                            
                        }, () => {
                            showConfirmDialog();
                        })
                });
            }


        } catch (ex) {
            console.log(ex);
            if (ex instanceof IdhaAppException) {
                dialogs.alert(ex.msg);
            } else {
                await LoadingBar.hide();
                idhaApiError(ex, 'manager');
                //dialogs.error($translate.instant("ERROR_MANAGER_" + ex.data.error.id));
                if (ex.data && ex.data.error && ex.data.error.errorCode) {
                    switch (ex.data.error.errorCode) {
                        case 1:
                            if ($scope.forms.formRegister.inpCpf)
                                $scope.forms.formRegister.inpCpf.$error = { alreadyRegistered: true };
                            break;
                        case 2:
                            if ($scope.forms.formRegister.inpEmail)
                                $scope.forms.formRegister.inpEmail.$error = { alreadyRegistered: true };
                            break;
                        case 3:
                            if ($scope.forms.formRegister.inpCnpj)
                                $scope.forms.formRegister.inpCnpj.$error = { alreadyRegistered: true };
                            break;
                        case 4:
                            if ($scope.forms.formRegister.inpEmailAdmin)
                                $scope.forms.formRegister.inpEmailAdmin.$error = { alreadyRegistered: true };
                            if ($scope.forms.formRegister.inpEmail)
                                $scope.forms.formRegister.inpEmail.$error = { alreadyRegistered: true };
                            break;
                    }
                }
            }

        } finally {
            LoadingBar.hide();
        }
    }

    ctrl.goBack = function () {
        if (!ctrl.cancelCallback) {
            dialogs.confirm($translate.instant('CONFIRM_GOBACK_DATA_LOST'), $translate.instant('YES'), $translate.instant('NO'))
                .then(() => {
                    History.back(null, 'app.html');
                });
        } else {
            ctrl.cancelCallback();
        }
    }

    //@TODO: Veriicar se este trecho pdoe ser removido
    ctrl.doLogin = async function () {
        ctrl.loginFailed = false;
        try {


            const { userId } = await UserIdha.login({
                email: ctrl.login,
                password: ctrl.password
            }).$promise

            const user = await UserIdha.findById({ id: userId }).$promise

            //após realizar o login com sucesso, guardar localmente o ownerId
            localStorageService.set("ownerId", ctrl.identifier);

            $state.go("home")

            // LoggedUserService.loggedUser = user;

            localStorageService.set("loggedUser", user)

        } catch (ex) {

            //caso o login seja negado, trata-se como um erro
            //checar se o erro é de não autorização (401)
            if (ex.status && ex.status == 401) {
                ctrl.loginFailed = true;
                $scope.$apply();
            } else {
                console.error(ex);
            }
        }
    }


    ctrl.onChangeCountry = function () {

    }

    ctrl.onChangeState = function () {
        ctrl.person.city = undefined;
        ctrl.person.district = undefined;
        ctrl.person.address = undefined;
    }

    ctrl.onChangeCity = function () {

    }

    ctrl.onChangeCountryText = function () {
        ctrl.person.zipCode = undefined;
        ctrl.person.state = undefined;
        ctrl.person.city = undefined;
        ctrl.person.district = undefined;
        ctrl.person.address = undefined;
    }

    ctrl.onChangeCityText = function () {
        ctrl.person.district = undefined;
        ctrl.person.address = undefined;
    }

    ctrl.personAlredyRegistered = function () {
        return ctrl.person.id != null
    }
}

utilsModule.component('loginRegister', {
    template: require('./login-register.component.html'),
    controller: ['$scope', 'Person', 'UserIdha', '$state', 'localStorageService', 'LoadingBar', 'dialogs', '$translate', 'LoginService', 'History', '$mdDialog', 'idhaApiError', 'thermOfUseAdherenceService', 'cpf', 'cnpj', 'cpfCnpj', loginRegisterController],
    bindings: {
        identifier: '<',
        pageLabel: '@?',
        cancelCallback: '=?',
        concludeCallback: '=?'
    }
});